// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import VueQuillEditor from 'vue-quill-editor'
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts'
import './assets/js/filters'
import './assets/css/base.scss'
import './assets/font/iconfont.css'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import '../static/ueditor/ueditor.config.js'
import '../static/ueditor/ueditor.all.min.js'
import '../static/ueditor/lang/zh-cn/zh-cn.js'
import '../static/ueditor/ueditor.parse.min.js' 

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueQuillEditor)
Vue.prototype.$echarts = echarts

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

router.beforeEach(function (to, from, next) {
  if (!sessionStorage.getItem('user') && to.path!=='/login') {
    next({
      path: '/login',
      name: 'login',
      query: { redirect: to.fullPath }
    })
  }else {
    next()
  }
})
console.log('v1.1.1')



// WEBPACK FOOTER //
// ./src/main.js